import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { useMediaQuery } from '@mui/material';
import { AppBar, Menu, Notification, Sidebar, defaultTheme } from 'react-admin';

import HeaderBarDashBoard from './../Header';

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    body: {
        backgroundColor: '#edecec',
        display: 'flex',
        flex: '1 1 auto',
        overflowY: 'hidden',
        overflowX: 'scroll',
    },
    bodySmall: {
        backgroundColor: '#fff',
    },
    content: {
        flex: 1,
        padding: '2em',
    },
    contentSmall: {
        flex: 1,
        paddingTop: '3em',
    },
    loader: {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: 16,
        zIndex: 1200,
    },
};

const Layout = (props) => {
    const {
        children,
        dashboard,
        isLoading,
        logout,
        menu,
        theme,
        title,
    } = props;

    const muiTheme = createTheme(theme);
    const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down('sm'));

    const prefixedStyles = {
        wrapper: styles.wrapper,
        main: styles.main,
        body: isSmallScreen ? styles.bodySmall : styles.body,
        content: isSmallScreen ? styles.contentSmall : styles.content,
    };

    return (
        <ThemeProvider theme={muiTheme}>
            <div style={prefixedStyles.wrapper}>
                <div style={prefixedStyles.main}>
                    {!isSmallScreen && <AppBar title={<HeaderBarDashBoard title={title} />} />}
                    <div className="body" style={prefixedStyles.body}>
                        <div style={prefixedStyles.content}>
                            {children}
                        </div>
                        <Sidebar theme={theme}>
                            {React.createElement(menu || Menu, {
                                logout,
                                hasDashboard: !!dashboard,
                            })}
                        </Sidebar>
                    </div>
                    <Notification />
                    {isLoading && (
                        <CircularProgress
                            className="app-loader"
                            color="inherit"
                            size={isSmallScreen ? 20 : 30}
                            thickness={2}
                            style={styles.loader}
                        />
                    )}
                </div>
            </div>
        </ThemeProvider>
    );
};

const componentPropType = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
]);

Layout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    dashboard: componentPropType,
    isLoading: PropTypes.bool.isRequired,
    logout: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func,
        PropTypes.string,
    ]),
    menu: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    title: PropTypes.node.isRequired,
    theme: PropTypes.object.isRequired,
};

Layout.defaultProps = {
    theme: defaultTheme,
};

const mapStateToProps = (state) => ({
    isLoading: state.admin.loading > 0,
});

export default connect(mapStateToProps)(Layout);
